<template>
  <div class="stylist-information">
    <span v-if="hasAge" data-test="age-label"
      ><img class="jm-img-contain" :src="profileIcon" /> {{ age }} ans</span
    >
    <span v-if="hasDistance" data-test="distance-label"
      >|<img class="jm-img-contain jm-px-1" :src="locationIcon" />à
      {{ distance }} km</span
    >
  </div>
</template>

<script>
import locationIcon from '@/assets/images/location-icon.png'
import profileIcon from '@/assets/images/profile-icon.png'

export default {
  name: 'StylistInformation',
  props: {
    age: {
      type: Number
    },
    distance: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      profileIcon,
      locationIcon
    }
  },
  computed: {
    hasDistance() {
      return !!this.distance
    },
    hasAge() {
      return !!this.age
    }
  }
}
</script>

<style lang="scss" scoped>
.stylist-information {
  font-size: 12px;
  line-height: 14.5px;
  span {
    margin-right: $spacing-2;

    > img {
      height: 1em;
      width: auto;
      margin-right: $spacing-1;
    }
  }
}
</style>
